import './App.css';
import Home from './ pages/Home/Home';
import Login from './ pages/Login/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { isAuthenticated } from './utils/auth';
import { UserProvider } from './context/UserContext';
import { Layout} from 'antd';
import Breadcrumbs from './components/Breadcrumb';
import Sidebar from './layouts/Sidebar';
import Header from './layouts/Header';
import AddForm from './ pages/AddWork/Add';
import Calculator from './ pages/Calculator/Calculator';
import { TransactionProvider } from './context/TransactionContext';
import { Navigate, Route, Routes } from 'react-router-dom';
import DoneWorks from './ pages/DoneWorks/DoneWorks';
import { CompletedTasksProvider } from './context/CompletedTasksContext';
import NotFound from './ pages/NotFound/NotFound';
import OilPage from './ pages/Oils/Oil';
import CarPage from './ pages/Car/Car';
import { CarProvider } from './context/CarContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OilBlank from './ pages/Oils/Blank';
import { OilProvider } from './context/OilContext';
import CarDetails from './ pages/Car/CarDeatils';
import CompletedTaskDetails from './ pages/DoneWorks/CompletedTaskDetails';
import TeamList from './ pages/team/TeamList';
import { MemberProvider } from './context/MembersContext';
import ProductsByTask from './ pages/Products/Products';
import { DashboardProvider } from './context/DashboardContext';

const { Content, Sider } = Layout;

const App = () => {
  const isAuth = isAuthenticated();

  return (
    <div className="App">
      <ToastContainer />
      <UserProvider>
        <TransactionProvider>
          <CompletedTasksProvider>
            <CarProvider>
              <OilProvider>
                <MemberProvider>
                  <DashboardProvider>
                    <Routes>
                      <Route
                        path="/login"
                        element={isAuth ? <Navigate to="/" /> : <Login />}
                      />
                      <Route
                        path="/"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={250} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <Home />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/done"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <DoneWorks />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/add"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <AddForm />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/transaction"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <Calculator />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/oil-done"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <OilPage />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/cars"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <CarPage />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/oil-blank"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <OilBlank />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/cars/:carId"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <CarDetails />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/done/:taskId"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <CompletedTaskDetails />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/team"
                        element={
                          isAuth ? (
                            <Layout>
                              <Header />

                              <Layout>
                                <Sider width={280} style={{ background: '#fff' }}>
                                  <Sidebar />
                                </Sider>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Breadcrumbs />
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <TeamList />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route
                        path="/products/:taskId"
                        element={
                          isAuth ? (
                            <Layout>
                              <Layout>
                                <Layout
                                  style={{
                                    padding: '0 24px 24px',
                                  }}
                                >
                                  <Content
                                    style={{
                                      padding: 24,
                                      margin: 0,
                                      minHeight: 280,
                                      background: '#fff',
                                    }}
                                  >
                                    <ProtectedRoute>
                                      <ProductsByTask />
                                    </ProtectedRoute>
                                  </Content>
                                </Layout>
                              </Layout>
                            </Layout>
                          ) : (
                            <Navigate to="/login" />
                          )
                        }
                      />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </DashboardProvider>
                </MemberProvider>
              </OilProvider>
            </CarProvider>
          </CompletedTasksProvider>
        </TransactionProvider>
      </UserProvider>
    </div>
  );
};

export default App;
